import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAirtable } from "../hooks/useAirtable";
import { useIframe } from "../hooks/useIframe";
import { useMediaQuery } from "react-responsive";

export function RecordResult({ category, name, number, year, domain }) {
  const [title, setTitle] = useState("");
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const [table, setTable] = useState([]);
  const [gender, setGender] = useState([]);
  const [event, setEvent] = useState([]);
  const [ranking, setRanking] = useState([]);
  const { fetchData } = useAirtable(category, "records");
  const { setMoveUrl } = useIframe(domain);

  useEffect(() => {
    const fetchDataAndSetData = async () => {
      const _title =
        category === "individual"
          ? "개인 참가"
          : category === "group"
          ? "단체 참가"
          : category === "club"
          ? "대항전 참가"
          : "개인 참가";
      const { fields, id } = await fetchData(
        `AND({name}="${name}", {number}="${number}", {year}="${year}")`
      );
      if (!fields || fields.length === 0) {
        alert(
          `${name}님의 ${year}년도 ${_title} 기록을 찾을 수 없습니다.\n이전 페이지로 돌아갑니다.`
        );
        setMoveUrl(`${domain}/records?mode=search&category=${category}`);
      } else {
        setTable([
          { key: "코스", value: fields.event },
          { key: "순위", value: fields.ranking },
          { key: "배번", value: number },
          { key: "이름", value: name },
          { key: "성별", value: fields.gender },
          { key: "기록", value: fields.record },
          { key: "출발", value: fields.startRecord },
          { key: "반환", value: fields.returnRecord },
        ]);
        setEvent(fields.event);
        setGender(fields.gender);
        setRanking(fields.ranking);
        setTitle(_title);
      }
    };
    fetchDataAndSetData();
  }, []);

  return (
    <Container ismobile={isMobile}>
      <Title>
        기록조회 <b>결과</b>
      </Title>
      <SubTitle>
        <b>{name}</b>
        님의 {title} 기록 내용입니다
      </SubTitle>
      <TableContainer ismobile={isMobile}>
        {table &&
          table.map((item) => (
            <TableWrapper ismobile={isMobile}>
              <TableKey ismobile={isMobile}>{item.key}</TableKey>
              <TableValue>{item.value}</TableValue>
            </TableWrapper>
          ))}
      </TableContainer>
      <SubTitle>
        <b>{name}</b>
        님의 {year}년도 대회 <b> {event}</b>에서{" "}
        <b>
          {gender} {ranking}
        </b>
        위를 하셨습니다
      </SubTitle>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: ${(props) => (props.ismobile ? "90%" : "82%")};
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 5rem 0;
`;
const Title = styled.div`
  color: #222;
  font-family: "Jalnan", sans-serif;
  font-size: 4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -0.8px;
  & b {
    color: #ff791a;
  }
`;
const SubTitle = styled.div`
  font-size: 2rem;
  font-style: normal;
  font-weight: 800;
  line-height: 150%;
  letter-spacing: -0.8px;
  margin: 6rem 0 3rem;
  & b {
    color: #ff791a;
    margin-right: 1rem;
  }
  & span {
    font-weight: 400;
    font-size: 1.4rem;
  }
`;
const TableContainer = styled.div`
  overflow: hidden;
  border-radius: 15px;
  border: 1.5px solid #d9d9d9;
  width: 100%;
  display: flex;
  box-sizing: border-box;
  flex-direction: ${(props) => (props.ismobile ? "column" : "row")};
  /* flex-direction: column; */
  & input[type="button"] {
    padding: 1.4rem 2rem;
    border: 1.2px solid #d9d9d9;
    background: #d9d9d9;
    color: #4f4f4f;
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.2px;
    cursor: pointer;
    margin-left: 1rem;
  }
  & > div {
    width: 100%;
    display: flex;
    align-items: center;

    box-sizing: border-box;
    &:last-child {
      border-right: 0;
    }
  }
`;

const TableWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.ismobile ? "row" : "column")};
  border-right: ${(props) => (props.ismobile ? "0" : "1.5px solid #d9d9d9")};
  border-bottom: ${(props) => (props.ismobile ? "1.5px solid #d9d9d9" : "0")};
  &:last-child {
    border-bottom: ${(props) => (props.ismobile ? "0" : "0")};
  }
`;

const TableKey = styled.div`
  box-sizing: border-box;
  width: 100%;
  border-bottom: ${(props) => (props.ismobile ? "0" : "1.5px solid #d9d9d9")};
  border-right: ${(props) => (props.ismobile ? "1.5px solid #d9d9d9" : "0")};
  background: #fff9ef;
  padding: 2.5rem;
  text-align: center;
  color: #555;
  font-weight: 800;
  font-size: 1.7rem;
  letter-spacing: -0.2px;
`;
const TableValue = styled(TableKey)`
  background: #fff;
  border-bottom: 0;
`;
